import React, { useContext } from 'react';

import PaymentMethods from '@/components/Profile/PaymentMethods';
import { usePaymentMethods } from '@/Utils/stripeHooks/usePaymentMethods';
import { EditProfileContext } from '@/contexts/EditProfileProvider';
import { BookingProviderContext } from '@/contexts/BookingProfileContext';
import { useQueryClient } from 'react-query';

export type CardDataType = { number: string; date: string };
export type PreviousBillingFormProps = {
  action?: string;
  cards?: CardDataType[];
  flight_id?: string;
  id?: string; // booking id
  idForDeletePayMethod?: string | null;
  defaultPaymentMethodId?: string | null;
  stripeKey: string;
};

const PreviousBillingForm: React.FC<PreviousBillingFormProps> = ({
  stripeKey,
  action,
  flight_id,
  id,
}) => {
  const { data: paymentMethods } = usePaymentMethods();
  const queryClient = useQueryClient();
  const { showAlert } =
    useContext(EditProfileContext) || useContext(BookingProviderContext);

  const handleShowAlert = () => {
    queryClient.invalidateQueries(['paymentMethods']);
    showAlert?.({
      type: 'error',
      title: 'Error',
      description: 'Payment method is invalid. Please go to the Billing tab, add a payment method, and try again.',
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (!paymentMethods || paymentMethods.length === 0) {
      e.preventDefault();
      handleShowAlert();
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      action={typeof action === 'string' ? action : undefined}
      method="POST"
      id="book_payment"
    >
      <input type="hidden" name="id" value={id} />
      <input type="hidden" name="flight_id" value={flight_id} />
      <PaymentMethods
        paymentMethods={paymentMethods}
        stripeKey={stripeKey}
        isBooking={true}
      />
      <button id="submit" className="btn my-5">
        <span id="button-text">Confirm</span>
      </button>
    </form>
  );
};
export default PreviousBillingForm;

